import { InlineIcon } from "@iconify/react";
import PropTypes from "prop-types";
import { useContext } from "react";
import { createUseStyles } from "react-jss";
import { TranslationContext } from "../../contexts";
import styleVariables from "../../style_setup";

const flags = {
  "en-GB": "twemoji:flag-for-united-kingdom",
  GR: "twemoji:flag-for-greece",
};

const styles = createUseStyles({
  LanguageMenuItem: {
    display: "grid",
    gridTemplateColumns: "repeat(2, max-content) 1rem",
    gap: "10px",
    alignItems: "center",
    justifyContent: "space-between",
  },
  [`@media ${styleVariables.media.smallscreen}`]: {},
});
export const LanguageMenuItem = ({ title = "", arg = "" }) => {
  const classes = styles({});

  const { i18n } = useContext(TranslationContext);

  return (
    <div className={classes.LanguageMenuItem}>
      <InlineIcon icon={flags[arg]} width="24" height="24" />
      {title}
      {i18n.language === arg && (
        <InlineIcon icon="ep:select" width="24" height="24" />
      )}
    </div>
  );
};
LanguageMenuItem.propTypes = {
  title: PropTypes.string,
  arg: PropTypes.string,
};
